import React, { ReactElement } from 'react'
import XmarkIcon from '@/icons/font-awesome/sharp-light/xmark.svg'

interface PictureWallBackButtonParams {
  onClick: () => void
  closePictureWallButtonLabel: string
}

export function PictureWallBackButton(props: PictureWallBackButtonParams): ReactElement {
  return (
    <div className="fixed top-0 z-10 bg-white w-screen">
      <button
        className='mx-auto my-4 flex gap-2 w-full max-w-screen-xl items-center justify-end px-4'
        onClick={props.onClick}
      >
        <span className='hidden md:inline'>{props.closePictureWallButtonLabel}</span>
        <XmarkIcon className='h-[20px] w-[20px] mr-2 md:mr-0' />
      </button>
    </div>

  )
}